import { render } from "./SchemesSearchPage.vue?vue&type=template&id=3cafc04a"
import script from "./SchemesSearchPage.vue?vue&type=script&lang=js"
export * from "./SchemesSearchPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindBack\\VindBackVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSpinnerBars from 'quasar/src/components/spinner/QSpinnerBars.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerBars,QBtn,QInput,QIcon,QToggle,QCheckbox,QBtnGroup,QPopupProxy,QDate,QOptionGroup,QSelect,QItem,QItemSection,QTooltip});qInstall(script, 'directives', {ClosePopup});
